import api from "PFCore/api";
import { Collection, Engagement } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

export type FetchEngagementsPayload = QueryParams<{ id?: number[]; term?: string }>;

export type EngagementResponseItem = { activity: Engagement; id: number };

export type FetchEngagementsResponse = Collection<EngagementResponseItem[]>;

export const fetchEngagements = (params: FetchEngagementsPayload): Promise<FetchEngagementsResponse> =>
  api({
    url: "engagements",
    params
  });
